import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'

const MultiOmicsPage = () => {
  return <TechnicalServicePage serviceKey="multiOmics" />
}

export default MultiOmicsPage
